export const STORAGE_MODES = Object.freeze({
  DYNAMIC: 'dynamic',
  VIRTUAL: 'virtual',
  DEDICATED: 'dedicated',
});

// 從 storage_mode 字串推導布林 flags。
// 用於 useStorageMode hook 內部，或任何拿到 warehouse 物件需要判斷 mode 的地方。
export function getStorageModeFlags(mode) {
  return {
    isDynamic:   mode === STORAGE_MODES.DYNAMIC,
    isVirtual:   mode === STORAGE_MODES.VIRTUAL,
    isDedicated: mode === STORAGE_MODES.DEDICATED,
  };
}
